import { Routes } from '@angular/router';
import { AppearanceComponent } from './appearance.component';
import { CanDeactivateAppearance } from './can-deactivate-appearance.guard';
import { AuthGuard } from '../../guards/auth-guard.service';
import { AppearanceEditorResolver } from './appearance-editor-resolver.service';
var ɵ0 = { permissions: ['appearance.update'] };
var routes = [
    {
        path: 'appearance',
        component: AppearanceComponent,
        data: ɵ0,
        resolve: { defaultSettings: AppearanceEditorResolver },
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateAppearance]
    },
];
var AppearanceRoutingModule = /** @class */ (function () {
    function AppearanceRoutingModule() {
    }
    return AppearanceRoutingModule;
}());
export { AppearanceRoutingModule };
export { ɵ0 };
